<template>
  <div class="concat">
    <div class="left">
      <ul>
        <li>
          <img src="../../assets/image/concat-icon1.png"
            alt="">
          <span class="name">客服郵箱</span> :
          <span class="con">info@aomiapp.com</span>
        </li>
        <li>
          <img src="../../assets/image/concat-icon3.png"
            alt="">
          <span class="name">Facebook</span> :
          <span class="con">澳覓-發現精彩澳門</span>
        </li>
        <li>
          <img src="../../assets/image/concat-icon4.png"
            alt="">
          <span class="name">Instagram</span> :
          <span class="con">aomi_macau</span>
        </li>
        <li>
          <img src="../../assets/image/concat-icon5.png"
            alt="">
          <span class="name">Wechat公眾號</span> :
          <span class="con">澳覓APP</span>
        </li>
        <li>
          <img src="../../assets/image/concat-icon6.png"
            alt="">
          <span class="name">地址</span>:
          <span class="con">澳門洗星海大馬路105號金龍中心9樓K</span>
        </li>
      </ul>
    </div>
    <img src="../../assets/image/concat.png"
      alt=""
      class="right">
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
.concat {
  width: 1200px;
  margin: 125px auto 0;
  display: flex;
  background-color: #ff6c43;
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 681px;
    background: linear-gradient(to bottom right, #ff3159, #ff6c43);
    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
      > img {
        width: 25px;
      }
      .name {
        display: block;
        width: 105px;
        text-align: justify;
        margin-left: 10px;
        padding-right: 5px;
        text-align: justify;
        text-align-last: justify;
        box-sizing: border-box;
      }
      .con {
        padding-left: 5px;
      }
    }
  }
  .right {
    display: block;
  }
}
</style>
